import React, { ReactNode } from "react"
import style from "./StorefrontDropdownMenu.module.scss"
import { Menu, MenuButton, MenuList } from "@reach/menu-button"
import "@reach/menu-button/styles.css"
import { cx } from "~/src/lib/style"

export type StorefrontDropdownMenuProps = {
  title: string
  className?: string
  children: ReactNode
}

export function StorefrontDropdownMenu(props: StorefrontDropdownMenuProps) {
  const { title, className, children } = props

  return (
    <Menu>
      <div className={cx([style.base, className])}>
        <MenuButton className={style.menuButton}>{title}</MenuButton>

        <MenuList className={style.menuList} portal={false}>
          {children}
        </MenuList>
      </div>
    </Menu>
  )
}
